import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { company, footerLinks } from "../data/company";

export function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-card/40"
    >
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-muted-foreground">
              {company.tagline}
            </p>
            <a
              href={`mailto:${company.emails.company}`}
              data-testid="footer-email"
              className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-foreground transition-colors hover:text-primary"
            >
              <Mail className="h-4 w-4" />
              {company.emails.company}
            </a>
          </div>

          <div className="md:col-span-4 md:col-start-7">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
              Navigate
            </p>
            <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                    className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
              Product
            </p>
            <a
              href="https://tanzeenplus.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-tanzeen-link"
              className="mt-5 inline-flex items-center gap-1 text-sm text-muted-foreground transition-colors hover:text-primary"
            >
              Tanzeen+
              <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-border pt-8 sm:flex-row">
          <p className="text-sm text-muted-foreground" data-testid="footer-copyright">
            © {new Date().getFullYear()} Envago Labs. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground">
              Privacy
            </Link>
            <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
